import Api from '@/services/Api'

export default {
    getAllTipoMoneda(){
        return Api().get('tipoMoneda/getAll')
    },
    getTipoMonedaById(id){
        return Api().get('tipoMoneda/tipoMonedaById/'+id)
    },
    createTipoMoneda(datos){
        return Api().post('tipoMoneda/create',datos)
    },
    updateTipoMonedaById(datos){
        return Api().put('tipoMoneda/update',datos)
    },
    deleteTipoMoneda(id){
        return Api().delete('tipoMoneda/delete/'+id)
    }
}